// extracted by mini-css-extract-plugin
export default {"label":"FormInput_label__sQOvy","input":"FormInput_input__m6swg","input--invalid":"FormInput_input--invalid__4tdsL","p":"FormInput_p__AYNOH"};